import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import getApiBaseUrl from '@/utils/getBaseUrl';

interface Payload {
  emailAddress?: string;
  name: string;
  phoneNumber?: string;
  imageUrl?: string;
  address?: string;
}

export default function useCreateMortgageCompany() {
  const queryClient = useQueryClient();
  const navigation = useNavigate();

  const token = window.localStorage.getItem('_token');

  return useMutation({
    mutationFn: async (payload: Payload) => {
      navigation('/dashboard');

      const response = await fetch(`${getApiBaseUrl()}/api/v1/mortgages`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch profile: ${response.statusText}`);
      }

      return (await response.json()).data;
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['ADMIN_MORTGAGE_COMPANIES'] });
    },
  });
}
